import { render, staticRenderFns } from "./beNull.vue?vue&type=template&id=3bf2e75c&scoped=true&"
import script from "./beNull.vue?vue&type=script&lang=ts&"
export * from "./beNull.vue?vue&type=script&lang=ts&"
import style0 from "./beNull.vue?vue&type=style&index=0&id=3bf2e75c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf2e75c",
  null
  
)

export default component.exports